import { makeStyles, createStyles } from '@material-ui/core/styles';

export const useStyles = makeStyles(({ palette, spacing, shape }) => createStyles({
    root: {
        padding: spacing(4),
        maxWidth: 1146,
        margin: "0 auto"
    }
}));